var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "embed-map-query-popup" },
    [
      _vm.MPAText.length > 0
        ? _c("h4", [_vm._v("Marine Protected Areas")])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.MPAText, function (MPA, i) {
        return _c("span", [
          _c(
            "span",
            {
              staticClass: "embed-link",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.redirect(MPA[1])
                },
              },
            },
            [_vm._v(_vm._s(MPA[0]))]
          ),
          i < _vm.MPAText.length - 1 ? _c("span", [_vm._v(", ")]) : _vm._e(),
          i === _vm.MPAText.length - 1 ? _c("span", [_vm._v(".")]) : _vm._e(),
        ])
      }),
      _vm._v(" "),
      _vm.MPAText.length > 0 ? _c("p", [_vm._v(" ")]) : _vm._e(),
      _vm._v(" "),
      _vm.byelawText.length > 0
        ? _c("h4", [_vm._v("Byelaws prohibiting bottom-towed fishing gear")])
        : _vm._e(),
      _vm._v("\n    " + _vm._s(_vm.byelawText) + "\n"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }